module.exports = __webpack_public_path__ + "img/quest_icon_0048_level.fed114b3.png";